import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';
import { HabitacionHotel } from '../../../models/habitacion-hotel';
import { NivelHotel } from '../../../models/nivel-hotel';
import { TipoHabitacionHotel } from '../../../models/tipo-habitacion-hotel';
import { HabitacionHotelService } from '../../../services/habitacion-hotel.service';
import { NivelHotelService } from '../../../services/nivel-hotel.service';
import { SessionService } from '../../../services/session.service';
import { TipoHabitacionHotelService } from '../../../services/tipo-habitacion-hotel.service';

@Component({
  selector: 'app-habitacion-edit-modal',
  templateUrl: './habitacion-edit-modal.component.html',
  styleUrls: ['./habitacion-edit-modal.component.css'],
  providers: [
    HabitacionHotelService,
    NivelHotelService,
    TipoHabitacionHotelService
  ],
})
export class HabitacionEditModalComponent implements OnInit {
  @Input() habitacion_id: String;
  @Output() sendHabitacionHotel = new EventEmitter();
  public nivelesHotel: Array<NivelHotel>;
  public tiposHabitacion: Array<TipoHabitacionHotel>;
  public habitacionHotel: HabitacionHotel;
  public msg: SweetMessage;
  public vl: Validation;
  public is_precio_editable: boolean;
  public loading: boolean;
  constructor(
    private habitacionHotelService: HabitacionHotelService,
    private nivelHotelService: NivelHotelService,
    private tipoHabitacionHotelService: TipoHabitacionHotelService,
    private ss: SessionService,
    public bsModalRef: BsModalRef,
  ) { 
    this.nivelesHotel = [];
    this.tiposHabitacion = [];
    this.habitacionHotel = new HabitacionHotel();
    this.msg = new SweetMessage();
    this.vl = new Validation();
    this.is_precio_editable = true;
    this.loading = false;
  }

  ngOnInit() {
    
    let p1 = this.getHabitacionById();
    let p2 = this.getNivelesHotel();
    let p3 = this.getTiposHabitacionHotel();

    Promise.all([p1,p2,p3]).then(
      res => this.loading = false,
      err => this.loading = false,
    )
  }

  getHabitacionById(){    
    return new Promise ( (resolve, reject) => {
      this.habitacionHotelService.getById(this.habitacion_id).subscribe(
        res => {
          
          this.habitacionHotel = res;
          
          // this.recalcularCuenta();
          // this.setValueForm();
          resolve();
        },
        err => {
          reject();
        }
      );
    });   
  }

  isValid(){
    if(this.habitacionHotel.codigo == ""){
      return false;
    }

    if(this.habitacionHotel.precio == 0){
      return false;
    }

    if(this.habitacionHotel.tipo_habitacion_id == ""){
      return false;
    }

    if(this.habitacionHotel.nivel_hotel_id == ""){
      return false;
    }
    return true;
  }


  getNivelesHotel(){
    return new Promise((resolve, reject)=>{
      let qs = "?status=A&empresa_id=" + this.ss.getData('empresa_id');
      this.nivelHotelService.getAll(qs).subscribe(
        res =>{
          this.nivelesHotel = res.data;
          resolve();
        },
        err =>{
          reject();
        });
    });
  }

  getTiposHabitacionHotel(){
    return new Promise((resolve, reject)=>{
      let qs = "?status=A&empresa_id=" + this.ss.getData('empresa_id');
      this.tipoHabitacionHotelService.getAll(qs).subscribe(
        res =>{
          this.tiposHabitacion = res.data;
          resolve();
        },
        err =>{
          reject();
        });
    });
  }

  onSubmit(){
    // this.setValueEntity();
    this.msg.showMessage('delete-confirm-message', "¿Está seguro de confirmar la modificación?").then(
			res => {
				
       
        
				this.loading = true;
				this.habitacionHotelService.update(this.habitacionHotel).subscribe(
					res => {
            this.msg.showMessage('success-message', 'Se ha procesado correctamente' );
            this.habitacionHotel = new HabitacionHotel();
            this.sendHabitacionHotel.emit(res.data);
						this.loading = false;
					},
					err => { 
						this.loading = false;
						this.msg.showMessage('error-message', err);
					}
				);
			}
		);
  }



}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/habitacion-edit-modal/habitacion-edit-modal.component.ts